import React, {Component} from 'react';
import {observe} from 'mobx';
import {observer, inject} from 'mobx-react';
import {getFloor} from "../../sources/Floor";
import {toSentence, pluralize} from "../../lib/Helpers";

import withLocationPersistence from '../hoc/WithLocationPersistence';

@inject('mapStore')
@withLocationPersistence
@observer
class MapLevels extends Component {

    constructor(props) {
        super(props);
        
    }

    componentWillMount() {
        if (this.props.mapStore.floor === null) {
          this.props.mapStore.floor = 0;
        }else if( !this.props.mapStore.floorGeojson.has(this.props.mapStore.floor) ) {
          // force a fetch of the initial floor geojson when we mount MapLevels
          const initialFloor = this.props.mapStore.floor;
          this.props.mapStore.floor = null;
          this.props.mapStore.floor = initialFloor;
        }
    }

    incrementFloor() {
        if (!this.isTopFloor()) {
            this.props.mapStore.floor += 1;
            this.updateStateAndLocationAttribute({currentTarget: {name: 'floor', value: this.props.mapStore.floor}});
        }
    }

    decrementFloor() {
        if (!this.isBottomFloor()) {
            this.props.mapStore.floor -= 1;
            this.updateStateAndLocationAttribute({currentTarget: {name: 'floor', value: this.props.mapStore.floor}});
        }
    }

    isTopFloor() {
        return this.props.mapStore.floor === 4
    }

    isBottomFloor() {
        return this.props.mapStore.floor === -1
    }

    render() {
      let message = "";
      
      if (this.props.mapStore.highlightedFeature) {
        const otherFloors = this.props.mapStore.highlightedFeature.floors.filter((f) => {return parseInt(f) !== this.props.mapStore.floor});
        if (otherFloors.length > 1) {
          message = `${pluralize(this.props.mapStore.highlightedFeature.title, 2)} also on levels ${toSentence(otherFloors)}`;
        } else if (otherFloors.length === 1) {
          message = `${pluralize(this.props.mapStore.highlightedFeature.title, 2)} are on level ${otherFloors[0]}`;
        }
      } else if (this.props.mapStore.trailStops.length > 0) {
        const otherFloors = [... new Set(this.props.mapStore.trailStops.filter((f) => {return parseInt(f.floor) !== this.props.mapStore.floor}).map((s) => s.floor))].sort();
        if (otherFloors.length > 1) {
          message = `Trail covers levels ${toSentence(otherFloors)}`;
        } else if (otherFloors.length === 1) {
          message = `Trail is on level ${otherFloors[0]}`;
        }
      }else if (this.props.mapStore.currentItem && this.props.mapStore.currentItem.hasOwnProperty('floors') && this.props.mapStore.currentItem.floors.length ) {
        const itemFloors = [...new Set(this.props.mapStore.currentItem.floors.map((i) => parseInt(i.level)))];
        const otherFloors = [... new Set(this.props.mapStore.currentItem.floors.filter((f) => parseInt(f.level) != this.props.mapStore.floor).map((f) => parseInt(f.level)))].sort();

        if( itemFloors.length === otherFloors.length ) {
          message = `Event is on ${pluralize('level', otherFloors.length)} ${toSentence(otherFloors)}`;
        }else if(itemFloors.length>1) {
          message = `Event is also on ${pluralize('level', otherFloors.length)} ${toSentence(otherFloors)}`;
        }
      } else if (this.props.mapStore.oldFloor !== null && this.props.mapStore.oldFloor !== this.props.mapStore.floor) {
        message = `The map is now showing level ${this.props.mapStore.floor}`;
        this.props.mapStore.oldFloor = null;
      }

      return <div className="m-floor-selector">
        <div className="current-floor">
          <span>Level {this.props.mapStore.floor}</span>
        </div>
        <button onClick={this.decrementFloor.bind(this)} disabled={this.isBottomFloor()} className="decrement-floor"><i className="fa fa-chevron-down"></i><span>Down</span></button>
        <button onClick={this.incrementFloor.bind(this)} disabled={this.isTopFloor()} className="increment-floor"><i className="fa fa-chevron-up"></i><span>Up</span></button>
        {message.length > 0 &&
        <div className="multi-floor-indicator is-active" key={`message`}>
          <span>{message}</span>
        </div>
        }
      </div>
    }
}

export default MapLevels;
